const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.54053 15.1078L4.67031 18.3564L1.4897 18.4237C0.53916 16.6607 0 14.6436 0 12.5C0 10.4272 0.504102 8.47251 1.39766 6.75137H1.39834L4.22998 7.27051L5.47041 10.0852C5.21079 10.842 5.06929 11.6545 5.06929 12.5C5.06938 13.4176 5.2356 14.2967 5.54053 15.1078Z",
  fill: "#FBBB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7817 10.1648C24.9252 10.921 25.0001 11.7019 25.0001 12.5C25.0001 13.3949 24.906 14.2678 24.7268 15.1099C24.1183 17.9753 22.5283 20.4773 20.3257 22.2479L20.325 22.2472L16.7584 22.0653L16.2536 18.9141C17.7151 18.057 18.8573 16.7156 19.459 15.1099H12.7749V10.1648H19.5565H24.7817Z",
  fill: "#518EF8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3249 22.2473L20.3256 22.2479C18.1834 23.9698 15.4623 25 12.5 25C7.73975 25 3.60103 22.3393 1.48975 18.4238L5.54058 15.1079C6.59619 17.9251 9.31392 19.9307 12.5 19.9307C13.8695 19.9307 15.1525 19.5604 16.2535 18.9142L20.3249 22.2473Z",
  fill: "#28B446"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4788 2.87773L16.4293 6.19297C15.2899 5.48076 13.943 5.06934 12.5 5.06934C9.2418 5.06934 6.47324 7.16685 5.47051 10.0852L1.39839 6.75137H1.39771C3.47808 2.74038 7.66899 0 12.5 0C15.533 0 18.3139 1.08037 20.4788 2.87773Z",
  fill: "#F14336"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  fill: "white"
})));
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c8df1432b1dc1d93c393f084e15f6065.svg";
export { ForwardRef as ReactComponent };